import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import NoteTypeForm from '../../../components/forms/NoteTypeForm';
import { useNoteTypeApi } from '../../../hooks/useNoteTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { NoteTypeDTO } from '../../../services/apiClient';

const NoteTypeEdit: React.FC = () => {
  const { getById, edit, isLoading } = useNoteTypeApi();
  const [entityData, setEntityData] = useState<NoteTypeDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Note Types', href: '/admin/notetypes' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching NoteType data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/notetypes');
    } catch (error) {
      console.error('Error updating NoteType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/notetypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.NoteType.Edit'
    >
        {entityData ? (
          <NoteTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/notetypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default NoteTypeEdit;